import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { ModelWizard } from '../../domain/eurocode';

@Component({
  selector: 'app-admin-models-form',
  templateUrl: './admin-models-form.component.html',
  styleUrls: ['./admin-models-form.component.scss']
})
export class AdminModelsFormComponent {
  // modelForm: FormGroup;
  // isEditMode: boolean = false;
  // modelId: number;

  // constructor(
  //   private fb: FormBuilder,
  //   private adminService: AdminService,
  //   private route: ActivatedRoute,
  //   private router: Router
  // ) {
  //   this.modelForm = this.fb.group({
  //     ModId: [{ value: '', disabled: true }, Validators.required],
  //     ManId: ['', Validators.required],
  //     ModCode: ['', Validators.required],
  //     MainCat: ['', Validators.required],
  //     SubCat: ['', Validators.required],
  //     LaunchYear: ['', Validators.required],
  //     Mod_En: ['', Validators.required],
  //     Mod_Fr: ['', Validators.required],
  //     Mod_Nl: ['', Validators.required],
  //     Mod_De: ['', Validators.required],
  //     Mod_It: ['', Validators.required],
  //     Mod_Es: ['', Validators.required],
  //     LabelName: ['', Validators.required]
  //   });
  // }

  // onSubmit(): void {
  //   if (this.modelForm.valid) {
  //     const model: ModelWizard = this.modelForm.getRawValue();
  //     if (this.isEditMode) {
  //       this.adminService.updateModel(this.modelId, model).subscribe(() => {
  //         this.router.navigate(['/admin-models']);
  //       });
  //     } else {
        
  //    model.ModId = 0;
  //       this.adminService.createModel(model).subscribe(() => {
  //         this.router.navigate(['/admin-models']);
  //       });
  //     }
  //   }
  // }

  // manufacturers: any[] = [];

  // loadManufacturers(): void {
  //   this.adminService.getManufacturersPaged(1,10000,'').subscribe(
  //     response => {
  //       this.manufacturers = response.Data;
  //       this.manufacturers = this.manufacturers.map(manufacturer => ({
  //         ...manufacturer,
  //         ManLabel: `${manufacturer.ManId} - ${manufacturer.ManCode} - ${manufacturer.Man_En}`
  //       }));
        
  //     },
  //     error => {
  //       console.error('Error fetching manufacturers', error);
  //     }
      
  //   );
  // }

  // ngOnInit(): void {
  //   this.route.params.subscribe(params => {
  //     if (params['id']) {
  //       this.isEditMode = true;
  //       this.modelId = params['id'];
  //       this.adminService.getModelById(this.modelId).subscribe(model => {
  //         this.modelForm.patchValue(model);
  //       });
  //     }
  //   });
  //   this.loadManufacturers();
  // }

}
